module.exports = __webpack_public_path__ + "img/privat24-web.cccee339.png";